<template>
  <div :class="rootClass">
    <div>
      <div class="war-room-sign-up-widget__head">
        <WarRoomLogoIcon class="war-room-sign-up-widget__logo" />
        <BravadoText tag="h3" variant="subhead-semibold" class="war-room-sign-up-widget__sign-up-header">
          Welcome to the Bravado War Room
        </BravadoText>
        <BravadoText tag="h4" variant="header5" class="war-room-sign-up-widget__sign-up-subheader">
          An exclusive Sales Community for the
        </BravadoText>
        <BravadoText tag="h4" variant="header5" class="war-room-sign-up-widget__sign-up-subheader--gold">
          Best Sales Professionals.
        </BravadoText>
      </div>
    </div>

    <div class="war-room-sign-up-widget__section">
      <WarRoomLandingVideo class="war-room-sign-up-widget__video" :video-id="videoId">
        <NuxtImg
          :src="videoPreviewSrc"
          class="war-room-sign-up-widget__video-preview"
          alt="Visual preview of a video which explains what the War Room is"
          width="240"
          height="134"
        />
        <PlayIcon
          width="40px"
          height="40px"
          class="war-room-sign-up-widget__play-icon"
          anal-click-name="war-room-landing__video-play-icon"
        />
      </WarRoomLandingVideo>
    </div>

    <div class="war-room-sign-up-widget__section">
      <BravadoTheme forced-theme="dark" class="war-room-sign-up-widget__footer">
        <button
          type="button"
          data-test="join-the-community-button"
          class="war-room-sign-up-widget__cta"
          @click="handleJoin"
        >
          Join the community
        </button>
      </BravadoTheme>
    </div>

    <p class="war-room-sign-up-widget__disclaimer">
      *Upon sign up we require LinkedIn Authentication to verify that you are a sales professional.
    </p>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import WarRoomLogoIcon from './assets/war-room-logo.vue.svg';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import WarRoomLandingVideo from '~/components/partials/war-room/WarRoomLandingVideo/WarRoomLandingVideo.vue';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme.vue';
import PlayIcon from '~/components/partials/war-room/WarRoomLandingVideo/images/play-button.vue.svg';

const VIDEO_ID = 'jwFpQHbsKlE';

export default Vue.extend({
  name: 'WarRoomSignUpWidget',
  components: {
    BravadoText,
    WarRoomLandingVideo,
    BravadoTheme,
    PlayIcon,
    WarRoomLogoIcon,
  },
  props: {
    alternative: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      videoId: VIDEO_ID,
    };
  },
  computed: {
    rootClass(): Record<string, boolean> {
      return {
        'war-room-sign-up-widget': true,
        'war-room-sign-up-widget--alternative': this.alternative,
      };
    },
    videoPreviewSrc(): string {
      return require('~/components/partials/war-room/WarRoomLandingVideo/images/video-preview.png');
    },
  },
  methods: {
    handleJoin() {
      this.$analytics.logEvent('war-room__war-room-sign-up-widget__join-the-community-button__click');
      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
  },
});
</script>

<style lang="scss" scoped>
.war-room-sign-up-widget {
  $this: &;

  display: grid;
  grid-auto-flow: row;
  grid-row-gap: 24px;
  padding: 16px;
  border-radius: 8px;
  background: var(--black);
  text-align: center;
  box-shadow: var(--theme-elevation-01);

  &--alternative {
    grid-row-gap: 30px;
    margin-top: 0;
    padding: 0;

    #{$this} {
      &__section {
        display: flex;
        justify-content: space-around;
      }

      &__video,
      &__footer {
        width: 320px;
      }
    }
  }

  &__logo {
    margin-bottom: -15px;
  }

  &__sign-up-header {
    color: var(--white);
    margin-bottom: 12px;
  }

  &__sign-up-subheader {
    color: var(--white);

    &--gold {
      color: var(--gold-20);
    }
  }

  &__video-preview {
    height: auto;
    max-width: 100%;
    border-radius: 4px;
  }

  &__play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -20px;
    color: var(--black-a65);
  }

  &__note {
    color: var(--gray-03);
  }

  &__counter {
    color: var(--gray-50);
  }

  &__footer {
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: 16px;
  }

  &__cta {
    @include body-semibold;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 12px;
    height: 40px;
    background: var(--gold-20);
    border-radius: 4px;
    border: none;
    outline: none;
    cursor: pointer;
    color: var(--black);

    &:focus {
      color: inherit;
    }
  }

  &__linkedin-icon {
    margin-right: 6px;
  }

  &__disclaimer {
    @include caption2;

    text-align: center;
    color: var(--theme-color-sub-text);
  }
}
</style>
